// -- other --
import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Log,Str,DateTime} from "biz9-utility";
import {Stat_Table} from "biz9-stat";
import {Image_Type,Image_Table,Image_Field,Image_Format} from "biz9-image";
import {User_Table,User_Logic,User_Field} from "biz9-user";
import {Portal_Type,Portal_Field,Portal_Url,Portal_Value_Type,Portal_Table,Portal_Remote_Data} from "biz9-portal-app";
import {Field,Message,Title,Type,Project_Table,Config} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
const Dashboard_Admin_User_Detail = () => {
   const query = UrlQuery();
   const [val_id,setValId] = useState(query.get('id'));
   const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0,{data:{stat_user:{}}}));
	useEffect(() => {
            Storage.post_dashboard_side_bar(Title.USER_SIDE_BAR_USER);
	    if(!Str.check_is_null(val_id)){
			get_data();
		}else{
            let not_found = User_Logic.get_not_found(0);
            not_found.stat_user = {last_login:'n/a'};
            setUser(not_found);
        }
		},[val_id]);
	async function get_data() {
        let foreign_stat_last_login = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.STAT,Portal_Field.USER_ID,Portal_Field.ID,{title:'stat_user',sort_by:{date_create:-1}});
        let option = {foreigns:[foreign_stat_last_login]};
        let parent = Data_Logic.get(Portal_Table.PRODUCT,123);
        const [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url.DATA_GET),Portal_Table.USER,val_id,option);
        setUser(data);

        /*
        let foreign_stat_last_login = Data_Logic.get_foreign(Portal_Value_Type.ONE,Stat_Table.STAT,User_Field.USER_ID,Portal_Field.ID,{title:'stat_user',sort_by:{date_create:-1}});
        let option = {foreigns:[foreign_stat_last_login]};
        const url = Remote.get_url(Config.APP_ID,Config.HOST,Portal_Url.DATA_GET);
        const form_data = {option:option,table:Portal_Table.USER,id:val_id};
        const [biz_response,biz_data] = await Remote.post(url,form_data);
        setUser(data);
        */
	}
  return (
    <>
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="main-title mb-4">
                <h4>Profile</h4>
              </div>
<Link to={all_routes.dashboard_admin_user}  className="nav-link" >
{"<- Back to Users"}
</Link>
            <br/>
             <div className="card profile-card">
                <div className="card-body">
                 <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
                    <div className="d-flex align-items-center flex-shrink-0">
                      <span className="avatar avatar-lg">
                        <ImageWithBasePath className="rounded-2" src={Image.get_url(user[Image_Field.IMAGE_FILENAME],Image_Format.SQUARE_THUMB)}
 alt="img" />
                      </span>
                      <div className="ms-3">
                        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
                          {user.username?user.username:"N/A"}
                        </h6>
                        <p className="mb-2">{User_Logic.get_country_state_city(user)}</p>
                      </div>
                    </div>
                    <Link hidden={!Str.check_is_null(user.id)?false:true} to={all_routes.dashboard_admin_user_edit+"?id="+query.get('id')} className="btn btn-lg btn-dark">
                      Edit
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card profile-details">
                <div className="card-header">
                  <h5 className="mb-0">Personal Details</h5>
                </div>
                <div className="card-body">
                  <div className="row row-gap-3">
                    <div className="col-md-4 col-sm-6">
                      <h6>First Name</h6>
                      <p className="mb-0">{user.first_name?user.first_name:"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Last Name</h6>
                      <p className="mb-0">{user.last_name?user.last_name:"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Email</h6>
                      <p className="mb-0">{user.email?user.email:"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Member Since</h6>
                      <p className="mb-0">{DateTime.get_date_short(user.date_create)}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Gender</h6>
                      <p className="mb-0">{user.gender?user.gender:"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Last Login</h6>
                      <p className="mb-0">{DateTime.get_date(user.stat_user.date_create)}{""} {DateTime.get_time(user.stat_user.date_create)}</p>
                    </div>
                  </div>
                </div>
 				<div className="card-body">
                  <div className="row row-gap-3">

                    <div className="col-md-4 col-sm-6">
                      <h6>Role</h6>
                      <p className="mb-0">{User_Logic.get_user_role_by_role(user.role).title}</p>
                    </div>

					<div className="col-md-4 col-sm-6">
                      <h6>Account Status</h6>
                      <p className="mb-0">{App.get_app_status_type_by_title(user.status_type)}</p>
                    </div>

                    <div className="col-md-4 col-sm-6">
                      <h6>ID</h6>
                      <p className="mb-0">{user.id}</p>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </>
  );
};

export default Dashboard_Admin_User_Detail;
